export default __webpack_public_path__ + "static/media/Web_About_us@1x.e66ae14f.png";